import React from 'react'
import styled from 'styled-components'
import { Link } from "react-router-dom";

import Navbar from '../SubComponents/Navbar'

// import party1 from "../assets/party1.jpg";
// import hotel2 from "../assets/hotel2.jpg";
// import img2 from "../assets/img2.png";

// import concert2 from '../assets/events/concert2.webp'
// import hotel4 from '../assets/events/hotel4.avif'
// import hotel5 from '../assets/events/hotel5.webp'
// import hotel6 from '../assets/events'

import hotel1 from '../assets/hotels/hotel1.jpg'
import hotel102 from '../assets/hotels/hotel102.jpg'
import hotel103 from '../assets/hotels/hotel103.jpg'
import hotel104 from '../assets/hotels/hotel104.jpg'
import hotel105 from '../assets/hotels/hotel105.jpg'
import hotel106 from '../assets/hotels/hotel106.jpg'

const Section = styled.div`
  width: 100vw;
  min-height: 100vh;

  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  /* align-items: center; */

  /* background-color: lavender; */
  /* background-color: #F9D199; */
    background-color: rgba(32, 32, 32, 0.3);
`;

const BlackWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
  background-color: rgba(32, 32, 32, 0.3);
`;

const ImageContainer = styled.div`
  width: 100%;
  height: calc(100vh - 6rem);

  img {
    width: 100%;
    height: 100%;
    object-fit: fill;
  }
`;

const Heading = styled.div`
  width: 85%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-self: flex-start;
  /* justify-content: center; */
  /* align-items: center; */
  padding: 0.5rem 2rem;
  font-size: 2rem;
  color: whitesmoke;
  /* color: ; */
  /* border: 1px solid red; */

  h2 {
    /* padding: 1rem; */
    font-size: 2rem;
  }
`;

const NewsBox = styled.div`
  width: 80%;
  height: auto;
  margin: 1rem auto;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: center;
  /* border: 2px solid red; */
`;

const MainContainer = styled.div`
  width: 35vw;
  height: 40vh;
  /* background-color: burlywood; */
  /* border: 1px solid brown; */
  margin: 1rem;
  position: relative;
  transition: all 0.2s ease;
  
  &:hover {
    transform: scale(1.1);
  }
  `;

const ImagContainer = styled.div`
  /* border: none; */
  width: 100%;
  height: 100%;
  object-fit: fill;
  
  img {
    border-radius: 25px;
    width: 35vw;
    height: 40vh;
  }
`;

const Event = styled.div`
  width: 90%;
  position: absolute;
  bottom: 1rem;
  left: 0.5rem;
  z-index: 5;
  color: white;
  padding: 4px 2px 4px 4px;
  /* border: 1px solid yellow; */

  h1 {
    font-size: 2rem;
    cursor: pointer;
    /* font-weight: 500; */
    color: orange;
  }

  h2 {
    font-size: 1rem;
  }

  h3 {
    font-size: 0.9rem;
  }
`;

const Details = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* border: 1px solid black; */

  div{
    display: flex;
    align-items: center;
  }
`;

const NewContainer = ({ img, link, hotel, location, prize }) => {
  return (
    <MainContainer>
      <ImagContainer>
        <img src={img} alt="news" />
      </ImagContainer>
      <Event>
        <Link to={{ pathname: `${link}`}} target="_blank" >
        <h1>{hotel}</h1>
        </Link>
        <Details>
        <div>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 0c-4.198 0-8 3.403-8 7.602 0 4.198 3.469 9.21 8 16.398 4.531-7.188 8-12.2 8-16.398 0-4.199-3.801-7.602-8-7.602zm0 11c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z"/></svg>
        <h3>{location}</h3>
        </div>
        <h3>{prize}</h3>
      
        </Details>
      </Event>
    </MainContainer>
  );
};

const Accomodations = () => {
  // const { loading, data: hotelData } = useQuery(QUERY_hotelS);
  // console.log(hotelData);
  return (
    <Section>
      <Navbar />
      <Heading>
        <h1>Beach Hotels..</h1>
        <h2>Stay at these luxurious hotels....</h2>
      </Heading>
      <NewsBox>
        <NewContainer
          img={hotel1}
          link="//www.tripadvisor.in/Hotel_Review-g181723-d1026878-Reviews-Walnut_Beach_Resort-Osoyoos_Okanagan_Valley_British_Columbia.html"
          hotel="Walnut Beach Resort"
          location="4200 Lakeshore Dr, Osoyoos, British Columbia V0H 1V6 Canada"
          prize="$420/-"
        />
        <NewContainer
          img={hotel104}
          link="//www.tripadvisor.in/Hotel_Review-g887226-d579734-Reviews-Westwind_Inn-Buckhorn_Municipality_of_Trent_Lakes_Ontario.html"
          hotel="Westwind Inn"
          location="37 Gallery on the Lake Road County Rd 36, Buckhorn, Municipality of Trent Lakes, Ontario K0L 1J0 Canada"
          prize="$452/-"
        />
        <NewContainer
          img={hotel103}
          link="//www.tripadvisor.in/Hotel_Review-g154942-d185449-Reviews-Pacific_Sands_Beach_Resort-Tofino_Clayoquot_Sound_Alberni_Clayoquot_Regional_District_V.html"
          hotel="Pacific Sands Resort"
          location="1421 Pacific Rim Hwy., Tofino, British Columbia V0R 2Z0 Canada"
          prize="$360/-"
        />
        <NewContainer
          img={hotel102}
          link="//www.tripadvisor.in/Hotel_Review-g154942-d182502-Reviews-Crystal_Cove_Beach_Resort-Tofino_Clayoquot_Sound_Alberni_Clayoquot_Regional_District_Va.html#/media/182502/459638529:p/?albumid=101&type=0&category=101"
          hotel="Crystal Cove Beach Resort"
          location="1165 Cedarwood Place, Tofino, British Columbia V0R 2Z0 Canada"
          prize="$325/-"
        />
        <NewContainer
          img={hotel105}
          link="//www.tripadvisor.in/Hotel_Review-g499287-d672351-Reviews-Shamrock_Lodge-Port_Carling_Muskoka_Lakes_Muskoka_District_Ontario.html"
          hotel="Shamrock Lodge"
          location="1090 Shamrock Road, Port Carling, Muskoka Lakes, Ontario P0B 1J0 Canada"
          prize="$490/-"
        />
        <NewContainer
          img={hotel106}
          link="//www.tripadvisor.in/Hotel_Review-g1841318-d3367015-Reviews-Cabot_Links_Resort-Inverness_Cape_Breton_Island_Nova_Scotia.html"
          hotel="Cabot Links Resort"
          location="15933 Central Avenue, Inverness, Nova Scotia B0E 1N0 Canada"
          prize="$412/-"
        />
      </NewsBox>
    </Section>
  );
};

export default Accomodations